import { type FC } from 'react';

import { currencyImages } from '@/components/helpers/imagesImports';

import cashPng from '/img/icons/cash.png';
import cashWebp from '/img/icons/cash.webp';
import dicePng from '/img/icons/dice.png';
import diceWebp from '/img/icons/dice.webp';
import starSvg from '/img/icons/gradient-star.svg';
import tcoinPng from '/img/tgem-big.png';
import tcoinWebp from '/img/tgem-big.webp';

interface CurrencyImageProps {
  kind: 'cash' | 'tgem' | 'star' | 'dice';
  size: string | number;
  className?: string;
  imageVariant?: 'default' | 'large';
}

const CurrencyImage: FC<CurrencyImageProps> = ({
  kind,
  size,
  className,
  imageVariant,
}) => {
  const images: Record<
    'cash' | 'tgem' | 'star' | 'dice',
    { webp?: string; png?: string; svg?: string }
  > = {
    cash: {
      webp: cashWebp,
      png: cashPng,
    },
    tgem: {
      webp: tcoinWebp,
      png: tcoinPng,
    },
    dice: {
      webp: diceWebp,
      png: dicePng,
    },
    star: {
      svg: starSvg,
    },
  };

  let image = images[kind];

  if (kind === 'cash' && imageVariant === 'large') {
    image = currencyImages.cash.large as { png: string; webp: string };
  }

  return (
    <div style={{ width: size, height: size }} className={className}>
      <picture className="w-full h-full">
        {image.webp && <source srcSet={image.webp} type="image/webp" />}
        {image.png && <img src={image.png} alt={kind} />}
        {image.svg && (
          <img className="w-full h-full" src={image.svg} alt={kind} />
        )}
      </picture>
    </div>
  );
};

export { CurrencyImage };
